export enum TicketAssociationResponseStatus {
  SUCCESS = 1,
  BAD_REQUEST,
  DATE_BEYOND_TICKET_VALIDITY,
  PASSWORD_DECRYPTION_ERROR,
  SYSTEM_FAILURE,
  TIMEOUT,
}
